import { createFormDropdown } from '@circlefin/form/Form.Dropdown'

// TODO: Investigate using L3OnboardingFieldNameType for name
export type L3OnboardingDropdownProps = Omit<
  React.ComponentProps<typeof Dropdown>,
  'maxMenuItems' | 'truncate' | 'loading'
>

const Dropdown = createFormDropdown()

export const L3OnboardingDropdown: React.FC<L3OnboardingDropdownProps> = ({
  ...props
}) => {
  return <Dropdown maxMenuItems={3} truncate={false} {...props} />
}
